export type GetCalendlySchedulingInfoPayload = {
  uni: string;
  eventType: string;
};

export type CalendlySchedulingInfoSuccessPayload = {
  eventType: string;
  schedulingUrl: string | null;
  name?: string | null;
  description?: string | null;
};

export type CalendlySchedulingInfoFailurePayload = {
  eventType: string;
  error: unknown;
};

export enum ApplyActionTypes {
  AGENT_REGISTER_APPLICANT = '@@student/AGENT_REGISTER_APPLICANT',
  AGENT_REGISTER_APPLICANT_SUCCESS = '@@student/AGENT_REGISTER_APPLICANT_SUCCESS',
  AGENT_REGISTER_APPLICANT_FAILURE = '@@student/AGENT_REGISTER_APPLICANT_FAILURE',

  UNI_REGISTER_APPLICANT = '@@student/UNI_REGISTER_APPLICANT',
  UNI_REGISTER_APPLICANT_SUCCESS = '@@student/UNI_REGISTER_APPLICANT_SUCCESS',
  UNI_REGISTER_APPLICANT_FAILURE = '@@student/UNI_REGISTER_APPLICANT_FAILURE',

  PARTNER_REGISTER_APPLICANT = '@@student/PARTNER_REGISTER_APPLICANT',
  PARTNER_REGISTER_APPLICANT_SUCCESS = '@@student/PARTNER_REGISTER_APPLICANT_SUCCESS',
  PARTNER_REGISTER_APPLICANT_FAILURE = '@@student/PARTNER_REGISTER_APPLICANT_FAILURE',

  CLEAR_SUCCESSFULL_REGISTER_APPLICANT_TOAST_MESSAGE = '@@student/CLEAR_SUCCESSFULL_REGISTER_APPLICANT_TOAST_MESSAGE',

  GET_APPLICATION_RECORD = '@@student/GET_APPLICATION_RECORD',
  GET_APPLICATION_RECORD_SUCCESS = '@@student/GET_APPLICATION_RECORD_SUCCESS',
  GET_APPLICATION_RECORD_FAILURE = '@@student/GET_APPLICATION_RECORD_FAILURE',

  GET_APPLY_AUDIT_LOG = '@@student/GET_APPLY_AUDIT_LOG',
  GET_APPLY_AUDIT_LOG_SUCCESS = '@@student/GET_APPLY_AUDIT_LOG_SUCCESS',
  GET_APPLY_AUDIT_LOG_FAILURE = '@@student/GET_APPLY_AUDIT_LOG_FAILURE',

  GET_OFFER_TIMELINE = '@@student/GET_OFFER_TIMELINE',
  GET_OFFER_TIMELINE_SUCCESS = '@@student/GET_OFFER_TIMELINE_SUCCESS',
  GET_OFFER_TIMELINE_FAILURE = '@@student/GET_OFFER_TIMELINE_FAILURE',

  GET_APPLY_EMAILS = '@@student/GET_APPLY_EMAILS',
  GET_APPLY_EMAILS_SUCCESS = '@@student/GET_APPLY_EMAILS_SUCCESS',
  GET_APPLY_EMAILS_FAILURE = '@@student/GET_APPLY_EMAILS_FAILURE',
  GET_APPLICANT_OFFER = '@@student/GET_APPLICANT_OFFER',
  GET_APPLICANT_OFFER_SUCCESS = '@@student/GET_APPLICANT_OFFER_SUCCESS',
  GET_APPLICANT_OFFER_FAILURE = '@@student/GET_APPLICANT_OFFER_FAILURE',
  UPDATE_APPLICANT_REQUIREMENT_STATUS = '@@student/GET_APPLICANT_REQUIREMENT_STATUS',
  UPDATE_APPLICANT_REQUIREMENT_STATUS_SUCCESS = '@@student/GET_APPLICANT_REQUIREMENT_STATUS_SUCCESS',
  UPDATE_APPLICANT_REQUIREMENT_STATUS_FAILURE = '@@student/GET_APPLICANT_REQUIREMENT_STATUS_FAILURE',
  UPDATE_APPLICANT_REQUIREMENT_LEVEL = '@@student/UPDATE_APPLICANT_REQUIREMENT_LEVEL',
  UPDATE_APPLICANT_REQUIREMENT_LEVEL_SUCCESS = '@@student/UPDATE_APPLICANT_REQUIREMENT_LEVEL_SUCCESS',
  UPDATE_APPLICANT_REQUIREMENT_LEVEL_FAILURE = '@@student/UPDATE_APPLICANT_REQUIREMENT_LEVEL_FAILURE',
  EXEMPT_APPLICANT_REQUIREMENT = '@@student/EXEMPT_APPLICANT_REQUIREMENT',
  EXEMPT_APPLICANT_REQUIREMENT_SUCCESS = '@@student/EXEMPT_APPLICANT_REQUIREMENT_SUCCESS',
  EXEMPT_APPLICANT_REQUIREMENT_FAILURE = '@@student/EXEMPT_APPLICANT_REQUIREMENT_FAILURE',
  EXEMPT_APPLICANT_INTERVIEW_REQUIREMENTS = '@@student/EXEMPT_APPLICANT_INTERVIEW_REQUIREMENTS',
  EXEMPT_APPLICANT_STAFF_REQUIREMENTS = '@@student/EXEMPT_APPLICANT_STAFF_REQUIREMENTS',
  EXEMPT_APPLICANT_OFFER_PAYMENT = '@@student/EXEMPT_APPLICANT_OFFER_PAYMENT',
  EXEMPT_APPLICANT_OFFER_PAYMENT_SUCCESS = '@@student/EXEMPT_APPLICANT_OFFER_PAYMENT_SUCCESS',
  EXEMPT_APPLICANT_OFFER_PAYMENT_FAILURE = '@@student/EXEMPT_APPLICANT_OFFER_PAYMENT_FAILURE',
  UPDATE_APPLICANT_OFFER_STATUS = '@@student/UPDATE_APPLICANT_OFFER_STATUS',
  UPDATE_APPLICANT_OFFER_STATUS_SUCCESS = '@@student/UPDATE_APPLICANT_OFFER_STATUS_SUCCESS',
  UPDATE_APPLICANT_OFFER_STATUS_FAILURE = '@@student/UPDATE_APPLICANT_OFFER_STATUS_FAILURE',
  REINSTATE_APPLICANT_OFFER = '@@student/REINSTATE_APPLICANT_OFFER',
  REINSTATE_APPLICANT_OFFER_SUCCESS = '@@student/REINSTATE_APPLICANT_OFFER_SUCCESS',
  REINSTATE_APPLICANT_OFFER_FAILURE = '@@student/REINSTATE_APPLICANT_OFFER_FAILURE',
  UPDATE_APPLICANT_OFFER_LETTER_TEXT = '@@student/GET_APPLICANT_OFFER_LETTER_TEXT',
  UPDATE_APPLICANT_OFFER_LETTER_TEXT_SUCCESS = '@@student/GET_APPLICANT_OFFER_LETTER_TEXT_SUCCESS',
  UPDATE_APPLICANT_OFFER_LETTER_TEXT_FAILURE = '@@student/GET_APPLICANT_OFFER_LETTER_TEXT_FAILURE',
  GET_APPLICANT_COURSES = '@@student/GET_APPLICANT_COURSES',
  GET_APPLICANT_COURSES_SUCCESS = '@@student/GET_APPLICANT_COURSES_SUCCESS',
  GET_APPLICANT_COURSES_FAILURE = '@@student/GET_APPLICANT_COURSES_FAILURE',
  GET_APPLICANT_INTAKES = '@@student/GET_APPLICANT_INTAKES',
  GET_APPLICANT_INTAKES_SUCCESS = '@@student/GET_APPLICANT_INTAKES_SUCCESS',
  GET_APPLICANT_INTAKES_FAILURE = '@@student/GET_APPLICANT_INTAKES_FAILURE',
  GET_APPLY_INTAKES = '@@student/GET_APPLY_INTAKES',
  GET_APPLY_INTAKES_SUCCESS = '@@student/GET_APPLY_INTAKES_SUCCESS',
  GET_APPLY_INTAKES_FAILURE = '@@student/GET_APPLY_INTAKES_FAILURE',
  GET_APPLICANT_COURSE_CHANGE = '@@student/GET_APPLICANT_COURSE_CHANGE',
  GET_APPLICANT_COURSE_CHANGE_SUCCESS = '@@student/GET_APPLICANT_COURSE_CHANGE_SUCCESS',
  GET_APPLICANT_COURSE_CHANGE_FAILURE = '@@student/GET_APPLICANT_COURSE_CHANGE_FAILURE',
  UPDATE_APPLICANT_PROGRAMME = '@@student/UPDATE_APPLICANT_PROGRAMME',
  UPDATE_APPLICANT_PROGRAMME_SUCCESS = '@@student/UPDATE_APPLICANT_PROGRAMME_SUCCESS',
  UPDATE_APPLICANT_PROGRAMME_FAILURE = '@@student/UPDATE_APPLICANT_PROGRAMME_FAILURE',
  CREATE_APPLICANT_OFFER = '@@student/CREATE_APPLICANT_OFFER',
  CREATE_APPLICANT_OFFER_SUCCESS = '@@student/CREATE_APPLICANT_OFFER_SUCCESS',
  CREATE_APPLICANT_OFFER_FAILURE = '@@student/CREATE_APPLICANT_OFFER_FAILURE',
  RESET_OFFER_CREATED = '@@student/RESET_OFFER_CREATED',
  UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS',
  UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS_SUCCESS = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS_SUCCESS',
  UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS_FAILURE = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_DEPOSIT_STATUS_FAILURE',
  UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS',
  UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS_SUCCESS = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS_SUCCESS',
  UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS_FAILURE = '@@student/UPDATE_APPLICANT_OFFER_PAYMENT_PROOF_STATUS_FAILURE',
  CREATE_ADDITIONAL_REQUIREMENTS = '@@student/CREATE_ADDITIONAL_REQUIREMENTS',
  CREATE_ADDITIONAL_REQUIREMENTS_SUCCESS = '@@student/CREATE_ADDITIONAL_REQUIREMENTS_SUCCESS',
  CREATE_ADDITIONAL_REQUIREMENTS_FAILURE = '@@student/CREATE_ADDITIONAL_REQUIREMENTS_FAILURE',
  SELECT_STUDIES_TO_ASSESS = '@@student/SELECT_STUDIES_TO_ASSESS',
  SELECT_STUDIES_TO_ASSESS_SUCCESS = '@@student/SELECT_STUDIES_TO_ASSESS_SUCCESS',
  SELECT_STUDIES_TO_ASSESS_FAILURE = '@@student/SELECT_STUDIES_TO_ASSESS_FAILURE',
  STUDENTS_TAGS_PIN = '@@student/STUDENTS_TAGS_PIN',
  STUDENTS_TAGS_PIN_SUCCESS = '@@student/STUDENTS_TAGS_PIN_SUCCESS',
  STUDENTS_TAGS_PIN_FAILURE = '@@student/STUDENTS_TAGS_PIN_FAILURE',
  STUDENTS_TAGS_UNPIN = '@@student/students_tags_unpin',
  STUDENTS_TAGS_UNPIN_SUCCESS = '@@student/students_tags_unpin_success',
  STUDENTS_TAGS_UNPIN_FAILURE = '@@student/students_tags_failure',
  UPDATE_APPLICANT_DETAILS = '@@student/UPDATE_APPLICANT_DETAILS',
  UPDATE_APPLICANT_DETAILS_SUCCESS = '@@student/UPDATE_APPLICANT_DETAILS_SUCCESS',
  UPDATE_APPLICANT_DETAILS_FAILURE = '@@student/UPDATE_APPLICANT_DETAILS_FAILURE',
  UPDATE_APPLICANT_DETAILS_RESET = '@@student/UPDATE_APPLICANT_DETAILS_RESET',
  UNLINK_APPLICANT_EMAIL = '@@student/UNLINK_APPLICANT_EMAIL',
  UNLINK_APPLICANT_EMAIL_SUCCESS = '@@student/UNLINK_APPLICANT_EMAIL_SUCCESS',
  UNLINK_APPLICANT_EMAIL_FAILURE = '@@student/UNLINK_APPLICANT_EMAIL_FAILURE',
  ASSIGN_APPLICANT_TO_AGENT = '@@student/ASSIGN_APPLICANT_TO_AGENT',
  ASSIGN_APPLICANT_TO_AGENT_SUCCESS = '@@student/ASSIGN_APPLICANT_TO_AGENT_SUCCESS',
  ASSIGN_APPLICANT_TO_AGENT_FAILURE = '@@student/ASSIGN_APPLICANT_TO_AGENT_FAILURE',
  UPDATE_APPLICANT_HIGHEST_QUALIFICATION = '@@student/UPDATE_APPLICANT_HIGHEST_QUALIFICATION',
  UPDATE_APPLICANT_HIGHEST_QUALIFICATION_SUCCESS = '@@student/UPDATE_APPLICANT_HIGHEST_QUALIFICATION_SUCCESS',
  UPDATE_APPLICANT_HIGHEST_QUALIFICATION_FAILURE = '@@student/UPDATE_APPLICANT_HIGHEST_QUALIFICATION_FAILURE',

  GET_APPLICANT_DOCUMENTS = '@@student/GET_APPLICANT_DOCUMENTS',
  GET_APPLICANT_DOCUMENTS_SUCCESS = '@@student/GET_APPLICANT_DOCUMENTS_SUCCESS',
  GET_APPLICANT_DOCUMENTS_FAILURE = '@@student/GET_APPLICANT_DOCUMENTS_FAILURE',

  GET_ALL_DOCUMENTS_WITH_COUNTS = '@@student/GET_ALL_DOCUMENTS_WITH_COUNTS',
  GET_ALL_DOCUMENTS_WITH_COUNTS_SUCCESS = '@@student/GET_ALL_DOCUMENTS_WITH_COUNTS_SUCCESS',
  GET_ALL_DOCUMENTS_WITH_COUNTS_FAILURE = '@@student/GET_ALL_DOCUMENTS_WITH_COUNTS_FAILURE',

  DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE = '@@student/DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE',
  DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE_SUCCESS = '@@student/DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE_SUCCESS',
  DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE_FAILURE = '@@student/DELETE_APPLICANT_OFFER_PROOF_OF_PAYMENT_FILE_FAILURE',

  GET_APPLY_UNI_LIST = '@@student/GET_APPLY_UNI_LIST',
  GET_APPLY_UNI_LIST_SUCCESS = '@@student/GET_APPLY_UNI_LIST_SUCCESS',
  GET_APPLY_UNI_LIST_FAILURE = '@@student/GET_APPLY_UNI_LIST_FAILURE',

  GET_ROUTE_STATUS = '@@student/GET_ROUTE_STATUS',
  GET_ROUTE_STATUS_SUCCESS = '@@student/GET_ROUTE_STATUS_SUCCESS',
  GET_ROUTE_STATUS_FAILURE = '@@student/GET_ROUTE_STATUS_FAILURE',

  UPDATE_DUPLICATE = '@@student/UPDATE_DUPLICATE',
  UPDATE_DUPLICATE_SUCCESS = '@@student/UPDATE_DUPLICATE_SUCCESS',
  UPDATE_DUPLICATE_FAILURE = '@@student/UPDATE_DUPLICATE_FAILURE',

  REQUEST_TASKS = '@@student/REQUEST_TASKS',
  REQUEST_TASKS_SUCCESS = '@@student/REQUEST_TASKS_SUCCESS',
  REQUEST_TASKS_FAILURE = '@@student/REQUEST_TASKS_FAILURE',

  GET_CALENDLY_SCHEDULING_INFO = '@@student/GET_CALENDLY_SCHEDULING_INFO',
  GET_CALENDLY_SCHEDULING_INFO_SUCCESS = '@@student/GET_CALENDLY_SCHEDULING_INFO_SUCCESS',
  GET_CALENDLY_SCHEDULING_INFO_FAILURE = '@@student/GET_CALENDLY_SCHEDULING_INFO_FAILURE',
}
